import React, {
  AnchorHTMLAttributes,
  ComponentType,
  ReactElement,
} from 'react';
import EditorUtils from '@draft-js-plugins/utils';
import { EditorState } from 'draft-js';
import DefaultLink, { LinkPubProps } from './components/link';
import LinkButton, { LinkButtonPubParams } from './components/link-button';
import DefaultLinkButton, {
  DefaultLinkButtonProps,
} from './components/default-link-button';
import linkStrategy from './link-strategy';
import { defaultTheme } from './theme';
import type { EditorPlugin } from '@draft-js-plugins/editor';
import type { AnchorPluginTheme } from './theme';

export { defaultTheme };
export type { AnchorPluginTheme } from './theme';
export type { DefaultLinkButtonProps } from './components/default-link-button';

export interface AnchorPluginConfig {
  theme?: AnchorPluginTheme;
  placeholder?: string;
  Link?: ComponentType<AnchorHTMLAttributes<HTMLAnchorElement>>;
  linkTarget?: string;
  validateUrl?: (url: string) => boolean;
  LinkButton?: ComponentType<DefaultLinkButtonProps>;
}

export type AnchorPlugin = EditorPlugin & {
  LinkButton: ComponentType<LinkButtonPubParams>;
};

export interface AnchorPluginStore {
  getEditorState?(): EditorState;
  setEditorState?(state: EditorState): void;
}

export default (config: AnchorPluginConfig = {}): AnchorPlugin => {
  const {
    theme = defaultTheme,
    placeholder,
    Link,
    linkTarget,
    validateUrl,
    LinkButton: linkButton,
  } = config;

  const store: AnchorPluginStore = {
    getEditorState: undefined,
    setEditorState: undefined,
  };

  const DecoratedDefaultLink = (props: LinkPubProps): ReactElement => (
    <DefaultLink {...props} className={theme.link} target={linkTarget} />
  );

  const DecoratedLinkButton = (props: LinkButtonPubParams): ReactElement => (
    // @ts-expect-error
    <LinkButton
      {...props}
      ownTheme={theme}
      store={store}
      placeholder={placeholder}
      onRemoveLinkAtSelection={() => store.setEditorState!(
        EditorUtils.removeLinkAtSelection(store.getEditorState!()),
      )}
      validateUrl={validateUrl}
      linkButton={linkButton || DefaultLinkButton}
    />
  );

  return {
    initialize: ({ getEditorState, setEditorState }) => {
      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },
    decorators: [
      {
        strategy: linkStrategy,
        component: Link || DecoratedDefaultLink,
      },
    ],

    LinkButton: DecoratedLinkButton,
  };
};
